<template>
	<v-container fluid id="consultas-container" class="d-flex flex-column">
		<v-btn-toggle style="width: 100%;" v-if="!$vuetify.breakpoint.mobile">
			<GlobalNewButton class="mr-2"/>
			<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 2 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(2)">
				<div class="d-flex align-start">
					<v-icon>mdi-view-list-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 3 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(3)">
				<div class="d-flex align-start">
					<v-icon>mdi-text-box-check-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 4 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(4)">
				<div class="d-flex align-start">
					<v-icon>mdi-chart-areaspline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Gráficos</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
					</div>
				</div>
			</v-btn>
			<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 5 ? 'selected':''" tile
				:disabled="!checkPermissions(['view_rdi'])"
				@click="changeListing(5)">
				<div class="d-flex align-start">
					<v-icon>mdi-file-document-edit-outline</v-icon>
					<div class="ml-2">
						<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
						<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
					</div>
				</div>
			</v-btn>
		</v-btn-toggle>
    <v-menu offset-y v-else>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
					rounded
					color="#2D4B95"
					dark
					small
					block
          v-bind="attrs"
          v-on="on"
        >
          Seleccione Acción
        </v-btn>
      </template>
			<div class="d-flex flex-column pa-2 white" style="gap: 5px;">
				<GlobalNewButton :fullWidth="true"/>
				<v-divider class="my-1"></v-divider>
				<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 2 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(2)">
					<div class="d-flex align-start">
						<v-icon>mdi-view-list-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Pendientes</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 3 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(3)">
					<div class="d-flex align-start">
						<v-icon>mdi-text-box-check-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Finalizadas</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 4 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(4)">
					<div class="d-flex align-start">
						<v-icon>mdi-chart-areaspline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Gráficos</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">RDI</p>
						</div>
					</div>
				</v-btn>
				<v-btn class="custom-button-consultas" :class="this.$store.rdiStore.state.selectedType === 5 ? 'selected':''" tile
					:disabled="!checkPermissions(['view_rdi'])"
					@click="changeListing(5)">
					<div class="d-flex align-start">
						<v-icon>mdi-file-document-edit-outline</v-icon>
						<div class="ml-2">
							<p class="mb-0 font-weight-bold text-capitalize">Borradores</p>
							<p class="mb-0 text-capitalize" style="font-size: 10px;opacity: 0.6;">Personales</p>
						</div>
					</div>
				</v-btn>
			</div>
    </v-menu>
		<div v-if="checkPermissions(['view_rdi'])">
			<ListadoRDI
				ref="listadoRDI"
				v-if="(this.$store.rdiStore.state.selectedType === 2 || this.$store.rdiStore.state.selectedType === 3) && !$vuetify.breakpoint.mobile"
				:ended="this.$store.rdiStore.state.selectedType === 3"/>
			<ListadoRDIMobile
				ref="listadoRDI"
				v-if="(this.$store.rdiStore.state.selectedType === 2 || this.$store.rdiStore.state.selectedType === 3) && $vuetify.breakpoint.mobile"
				:ended="this.$store.rdiStore.state.selectedType === 3"/>
			<RdiGraphs v-if="this.$store.rdiStore.state.selectedType === 4" />
			<ListadoBorradores
				v-if="this.$store.rdiStore.state.selectedType === 5"
				:draftType="2"
				@loadDraft="loadDraft"
			/>
		</div>
		<div v-else class="d-flex flex-column align-center justify-center" style="height: 100%;min-height: 300px;">
			<v-icon size="50" color="grey lighten-1">mdi-lock</v-icon>
			<p class="text-center mt-2 mb-0 text--grey">No tienes permisos para ver las RDI.</p>
			<p class="text-center caption text--grey">Contacta con el administrador del proyecto.</p>
		</div>
	</v-container>
</template>

<script>
import ListadoRDI from './ListadoRDI'
import ListadoRDIMobile from './ListadoRDIMobile'
import ListadoBorradores from '@/components/Globals/Helpers/ListadoBorradores'
import RdiGraphs from './RdiGraphs'
import GlobalNewButton from '@/components/Globals/Helpers/GlobalNewButton'
import {getRdiByID} from '@/helpers/api/rdi'

export default {
	name: 'RdiContainer',
	components: {ListadoRDI, ListadoRDIMobile, ListadoBorradores, RdiGraphs, GlobalNewButton},
	data: () => ({
		createTareaModal: false,

	}),
	mounted(){
		this.getRDIList()
		// if(!this.checkPermissions(['view_rdi'])){
		// 	this.$store.rdiStore.commit('setSelectedType', 0)
		// }
	},
	methods: {
		loadDraft(draft){
			const draftType = draft.raw_type
			
			if(draftType === 2) {
				this.$store.rdiStore.commit('setDraftToLoad', draft)
				this.$store.rdiStore.commit('setCreateRDIModal', true)
			}
			else if(draftType === 6) {
				this.$store.rdiStore.commit('setDraftToLoad', draft)
				this.viewRDI(draft.morphable_id)
			}
		},
		async viewRDI(rdi_id){
			this.$store.rdiStore.commit('setCurrentRDI', {loading: true})
			const rdi = await getRdiByID({rdi_id})
			if(rdi.code === 200){
				let rdiData = rdi.rdi
				this.$store.rdiStore.commit('setCurrentRDI', rdiData)
			}
		},
		async changeListing(selected){
			if(this.$store.rdiStore.state.selectedType != selected){
				this.$store.rdiStore.commit('setSelectedType', selected)
				if(selected == 4){
					this.getRdiGraphsData()
				}
				await this.$nextTick()
				if(this.$refs.listadoRDI){
					this.$refs.listadoRDI.clearFilters()
					this.$refs.listadoRDI.getRDIList()
				}
			}
		},
		getRdiGraphsData(){
			let project_id = null
			if(this.$store.projectsStore.state.selectedProject){
				project_id = this.$store.projectsStore.state.selectedProject.id
			}
			else{
				const id = localStorage.getItem('selectedProjectID')
				project_id = parseInt(id)
			}
			if(project_id){
				this.$store.rdiStore.dispatch('getRdiGraphsData', {project_id})
			}
		},
		async getRDIList(){
			// if(this.checkPermissions(['view_rdi'])){
				let project_id = null
				if(this.$store.projectsStore.state.selectedProject){
					project_id = this.$store.projectsStore.state.selectedProject.id
				}
				else{
					const id = localStorage.getItem('selectedProjectID')
					project_id = parseInt(id)
				}
				if(project_id){
					this.$store.rdiStore.dispatch('getRDI', {project_id})
				}
			// }
		}
	}
};
</script>

<style scoped>
	.text-primary{color: #2D4B95;}
	.custom-button-consultas.v-btn{
		background-color: white;
		color: #2D4B95;
		opacity: 1!important;
		text-align: left;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon,
	/deep/ .custom-button-consultas.v-btn p{
		color: #2D4B95!important;
		font-size: 13px;
	}
	/deep/ .custom-button-consultas.v-btn .v-icon{font-size: 20px;}
	/deep/ .custom-button-consultas.v-btn:hover .v-icon,
	/deep/ .custom-button-consultas.v-btn:hover p,
	/deep/ .custom-button-consultas.v-btn.selected .v-icon,
	/deep/ .custom-button-consultas.v-btn.selected p{
		color: white!important;;
	}
	.custom-button-consultas.selected,
	.custom-button-consultas:hover{
		background-color: #2D4B95!important
	}

</style>